import { rng } from '../utils';

export class Particle {

  constructor(width, height, emojiId) {
    const reactionImg = new Image();
    reactionImg.src = require(`../assets/reactions/small/${emojiId}.png`);
    
    const maxWidth = width > 1000 ? 240 : width > 750 ? 160 : 120;
    const minWidth = width > 800 ? 10: 0;
    const baseScale = width > 1000 ? 0.8 : width > 750 ? 0.6 : 0.5;
    
    this.x = Math.round(rng(minWidth, maxWidth));
    this.y = height - Math.round(rng(-20, 50));
    this.angle = 0;
    this.speed = 0.4 + rng(0, 0.3);
    this.speed_delta = height > 900 ? 10 : height > 700 ? 6 : 4;
    this.scale = baseScale + rng(-0.2, 0.4);
    this.opacity = 1;
    this.image = reactionImg;
  }

  moveAhead(height) {
    if (this.y < 80) {
      this.scale -= 0.02;
      this.opacity -= 0.01;
      this.y -= 0.5;
    }

    if (this.y < height / 3) {
      this.x += 0.5;
    }
    else if (rng(0, 10) % 2 == 0) {
      this.x += rng(0, 0.4);
    }
    else {
      this.x -= rng(0, 0.4);
    }

    this.y -= this.speed * this.speed_delta;
  }
}
